import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface BankruptcyWarningProps {
  bankruptcyWarnings: number;
  onClose: () => void;
}

export function BankruptcyWarning({ bankruptcyWarnings, onClose }: BankruptcyWarningProps) {
  return (
    <>
      <div className="bg-theme-bg-secondary border-l-4 border-theme-error p-4">
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0">
            <AlertTriangle className="w-6 h-6 text-theme-error" />
          </div>
          <h3 className="text-lg font-medium text-theme-text-primary">
            Bankruptcy Warning
          </h3>
        </div>
      </div>
      <div className="p-6">
        <p className="text-theme-text-secondary mb-6">
          Your company is operating at a significant loss! You have received {bankruptcyWarnings} out of 3 warnings.
          If you receive 3 warnings, your company will be declared bankrupt and the game will end.
        </p>
        <div className="space-y-4">
          <div className="bg-theme-bg-secondary border-l-4 border-theme-error p-4 rounded-lg">
            <h4 className="font-medium text-theme-text-primary mb-2">Recommendations:</h4>
            <ul className="list-disc list-inside text-sm text-theme-text-secondary space-y-1">
              <li>Review and optimize your product pricing strategy</li>
              <li>Cut unnecessary operational costs</li>
              <li>Consider discontinuing underperforming products</li>
              <li>Focus on high-margin products and services</li>
            </ul>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-full px-4 py-2 bg-theme-error text-white rounded-lg hover:opacity-90 transition-colors focus:outline-none focus:ring-2 focus:ring-theme-error focus:ring-offset-2"
          >
            I Understand
          </button>
        </div>
      </div>
    </>
  );
}